import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as formsAction from "../../redux/actions/formsAction";
import Confirm from "../../helper/component/Confirm"
import { initiateAuth, IsGCloudRegistered } from './_gCloudAuth';

function mapStateToProps(state) {
    return {
        data: state.formDataReducer,
        token: state.formLoginReducer.token,
        hasErrored: state.formDataReducer.hasErrored,
        isLoading: state.formDataReducer.isLoading,
    };
}
function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(formsAction.updateData(key, value, storekey)),
        dataIsLoading: (bool) => dispatch(formsAction.dataIsLoading(bool)),
    };
}

class Oauth extends React.PureComponent {
    state = {
        isApiCalling: true,
        gcloudAuthenticated: false
    }
    componentDidMount() {
        this.isGOuthAuthenticated();
        // if (window.addEventListener) {
        //     window.addEventListener("message", this.handleMessage.bind(this), false);
        // } else {
        //     window.attachEvent("onmessage", this.handleMessage.bind(this));
        // }
    }
    async isGOuthAuthenticated() {
        this.setState({ isApiCalling: true });
        let _IsGCloudRegistered = await IsGCloudRegistered(this.props.token);
        debugger;
        if (_IsGCloudRegistered.data && _IsGCloudRegistered.data.authentication === true) {
            this.setState({ gcloudAuthenticated: true });
        }
        this.setState({ isApiCalling: false });
    }
    OAuthClick = async () => {
        const { token, control } = this.props;
        debugger;
        if (control.logintype === 'google') {
            this.setState({ isApiCalling: true });
            this.props.dataIsLoading(true);

            var response = await initiateAuth(token);
            this.props.dataIsLoading(false);
            this.setState({ isApiCalling: false });
            var Wnd = window.open(response.data, '_blank', 'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=200,width=900,height=500');
            var WndInterval = setInterval(() => {
                if (Wnd.closed) {
                    clearInterval(WndInterval);
                    this.isGOuthAuthenticated();
                }
            }, 100);

        } else if (control.logintype === 'microsoft') {

        } else if (control.logintype === 'facebook') {

        } else if (control.logintype === 'linkedin') {

        }
    }
    render() {
        const { control } = this.props;
        const { gcloudAuthenticated } = this.state;
        var customStyle = {};
        if (control.styles) {
            try {
                customStyle = JSON.parse(control.styles);
            } catch {
                customStyle = {};
            }
        }
        return (
            <Confirm title="Authenticated!!!" description={'Do you want to proceed?'}>
                {confirm => <React.Fragment>
                    <button aria-label='Authenticated' data-tip data-for={control.id} onClick={gcloudAuthenticated ? confirm(this.OAuthClick.bind(this)) : this.OAuthClick.bind(this)}
                        className={' btn ' + control.coutomClass + ' btn-' + control.buttontype + ' btn-' + control.size}
                        style={customStyle}
                    >
                        {control.WebIcon &&
                            <i className={control.WebIcon + (control.label ? ' mr-2' : '')}></i>
                        }
                        {control.label}

                    </button>
                    {gcloudAuthenticated && <p className="text-success"><i className="fa fa-check-circle"> Authenticated!</i></p>}
                </React.Fragment>
                }
            </Confirm>
        );
    }
}
Oauth.contextTypes = {
    isAddFormClicked: PropTypes.string,
    history: PropTypes.object
};
export default connect(
    mapStateToProps, bindAction
)(Oauth);